export default {
    find_offers_by: 'Pronađi usluge po',
}
